import { uploadBytes } from 'firebase/storage'
import { collectionImagesRef } from 'firebaseAdapter/storageRefs'
import { CollectionImages } from 'firebaseAdapter/types'

const addUpdateCollectionBannerImage = (collectionId: string, file: File) =>
  uploadBytes(collectionImagesRef(collectionId, CollectionImages.BANNER), file)

export default addUpdateCollectionBannerImage
